import { render, staticRenderFns } from "./MaterialPreview.vue?vue&type=template&id=08aa6590&scoped=true"
import script from "./MaterialPreview.vue?vue&type=script&lang=js"
export * from "./MaterialPreview.vue?vue&type=script&lang=js"
import style0 from "./MaterialPreview.vue?vue&type=style&index=0&id=08aa6590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa6590",
  null
  
)

export default component.exports